import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Field } from 'src/app/tools/models/dtos/field';
import { ProductLovComponent } from 'src/app/assabil-admin/components/master-data/product/product-lov/product-lov.component';
import { PackingOrderPipe } from '../../pipes/packing-order-pipe';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { PackingOrderService } from '../../services/packing-order.service';
import { PackingOrder } from '../../models/entities/packing-order';
import { MatDialog } from '@angular/material/dialog';
import { PackingProcessService } from '../../services/packing-process.service';
import { PackingOrderStep } from '../../models/entities/packing-order-step';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { PackingOrderProduct } from '../../models/entities/packing-order-product';


@Component({
    selector: 'packing-order-list',
    templateUrl: './packing-order-list.component.html',
    styleUrls: ['./packing-order-list.component.scss']
})


export class PackingOrderListComponent extends BasePage2<PackingOrder> {

    branchLovComponent      = BranchLovComponent;
    productLov              = ProductLovComponent;

    packListFields          : Field[];
    batchListFields         : Field[];
    
    
    id                      : number;
    name                    : string;
    rank                    : number;
    packingOrderPipe        : PackingOrderPipe = new PackingOrderPipe();
   
    branch                  : Branch       = new Branch();
    product                 : Product      = new Product();
    startDate               : Date; 
    endDate                 : Date;
    includeOpened           : boolean      = true;
    includeClosed           : boolean      = false;
    
    packingOrders           : PackingOrder[]

    constructor(
        protected toastr                : ToastrService,
        protected packingOrderService   : PackingOrderService,
        protected packingProcessService : PackingProcessService,
        protected router                : Router,
        protected masterDataService     : MasterDataService,
        protected baseService           : BaseService,
        protected leanUtilsService      : LeanUtilsService, 
        protected dialog                : MatDialog,
        protected location              : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'packingOrder';

         this.baseService.fieldsGet("packingOrderProductPack").then(result => {
              this.packListFields = result.listFields;
        });
        this.baseService.fieldsGet("packingOrderBatch").then(result => {
                this.batchListFields = result.listFields;
        });
    }

    getRows(): PackingOrder[] {
        return this.packingOrders;
    }


    //---------------------------------------------------------------------------------------------------------------
    selectRow(po : PackingOrder){
        this.packingOrderService.packingOrderGet(po.id).then(packingOrder => {
            if (packingOrder.packingOrderProducts){
                for (let packingOrderProduct of packingOrder.packingOrderProducts){
                    packingOrderProduct.assignedQuantity = 0;
                    for (let packingOrderProductPack of packingOrderProduct.packingOrderProductPacks){
                        packingOrderProduct.assignedQuantity +=  packingOrderProductPack.quantity;
                    }
                }
            }
            this.selectedRow = packingOrder;
        })
    }
    //---------------------------------------------------------------------------------------------------------------


    //---------------------------------------------------------------------------------------------------------------
    newPackingOrder(){

        let branch : Branch = new Branch()
        branch.id = -1; // with available machine in user branch

        let packingOrder : PackingOrder = new PackingOrder();
        packingOrder.theDate        = new Date()
        packingOrder.branch         = branch;

        packingOrder.role            = this.baseService.userService.userInfo.person.role;
        packingOrder.person          = this.baseService.userService.userInfo.person;

        packingOrder.progressLevel  = 0;
        packingOrder.inserted       = true;
        packingOrder.edit           = true;
    
        let dialogRef = this.dialog.open(ProductLovComponent, {autoFocus : false, hasBackdrop : false});
        dialogRef.afterClosed().subscribe(product => {
        if(product){
            packingOrder.product    = product;

            this.newPackingOrder2(packingOrder, branch);
        }
        });    
    }
    //---------------------------------------------------------------------------------------------------------------


    //---------------------------------------------------------------------------------------------------------------
    newPackingOrder2(packingOrder: PackingOrder, branch : Branch) {
        this.packingProcessService.packingProcessGet(packingOrder.product.packingProcessId, branch.id).then(packingProcess => {
            packingOrder.packingProcess = packingProcess;
            packingOrder.packingOrderSteps = [];

            if (packingProcess.packingProcessSteps) {
                for (let packingProcessStep of packingProcess.packingProcessSteps){
                    let packingOrderStep	: PackingOrderStep = new PackingOrderStep();
                    packingOrderStep.packingProcessStep = packingProcessStep;
                    packingOrderStep.rank               = packingProcessStep.rank;
                    packingOrderStep.inserted           = true;
                    if (   (packingProcessStep.packingMachines)
                        && (packingProcessStep.packingMachines.length == 1) ) {
                        packingOrderStep.packingMachine = packingProcessStep.packingMachines[0];
                    }
                    packingOrder.packingOrderSteps.push(packingOrderStep);
                }
            }
   

            this.masterDataService.productGet(packingOrder.product.id).then(product => {
                packingOrder.packingOrderProducts = [];
                if (product.productSpareProducts) {
                    for ( let productSpareProduct of product.productSpareProducts){
                        let packingOrderProduct : PackingOrderProduct = new PackingOrderProduct();
                        packingOrderProduct.product = productSpareProduct.spareProduct;
                        packingOrderProduct.quantity = productSpareProduct.quantity;
                        packingOrder.packingOrderProducts.push(packingOrderProduct);
                    }
                }
    
                this.selectedRow = packingOrder;
            });
        });



    }
    //---------------------------------------------------------------------------------------------------------------
  

    //---------------------------------------------------------------------------------------------------------------
    loadData() {

        let branchId : number = null;
        let productId : number = null;

        if (this.branch) branchId = this.branch.id;
        if (this.product) productId = this.product.id;
        
        this.packingOrderService.packingOrdersGet(branchId, productId, this.startDate, this.endDate, this.includeOpened, this.includeClosed).then(result => {
                this.packingOrders = result;
            }).catch(error => {
                this.showError(error);
        })
    }
    //---------------------------------------------------------------------------------------------------------------
        
    //---------------------------------------------------------------------------------------------------------------
    enrichField(field : Field){
     //   if ( (field.prop == 'barCode') || (field.prop == 'assetStatusCode')  || (field.prop == 'ticketsNumber') ) {
     //       field.pipe = this.packingOrderPipe;
     //       return;
     //   }
    }
   //---------------------------------------------------------------------------------------------------------------
 
}
